import API from '@/api';

class Prescreening
{
  /**
   * Do api call to get all pre-screening steps per mission
   *
   * @return {promise}
   */
  static async listPrescreeningSteps(params, id) {
    return await API.dispatch(
      'GET',
      'prescreeningSteps',
      {
        query: params,
        path: { id }
      }
    );
  }

  /**
   * Do api call to get all pre-screening steps per mission
   *
   * @return {promise}
   */
  static async storeApplication(params, id) {
    return await API.dispatch(
      'POST',
      'storeApplication',
      {
        path: { id },
        data: params
      },
      {
        'Content-Type': 'application/json'
      }
    );
  }
}

export default Prescreening;